module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "arrow-up-green.cba36635.png";